// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"11ce3fd0","162":"72017fce","688":"8815cddf","875":"0e5957a3"}[chunkId] + ".chunk.css";
};